/* Budli "Similar items" for product pages (replaces Shopify's generic "you may also like" picks).
   Picks in-stock products of the same type, ranked by brand, price closeness, condition and specs.
   Falls back to Shopify's native recommendations if too few similar products are found. */
(function () {
  if (customElements.get('similar-products')) return;

  var SECTION = 'similar-products';
  var CONDITION = ['unboxed', 'refurbished', 'usable', 'preowned', 'pre-owned', 'open box', 'like new', 'good condition', 'superb'];

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fetchSection(q) {
    var url = '/search?type=product&q=' + encodeURIComponent(q) + '&section_id=' + SECTION;
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('similar: ' + r.status);
      return r.text();
    }).then(function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  function candidates(q) {
    return fetchSection(q).then(function (doc) {
      var el = doc.querySelector('script[data-similar-json]');
      if (!el) return [];
      try { return JSON.parse(el.textContent).filter(Boolean); } catch (e) { return []; }
    }).catch(function () { return []; });
  }

  function tagSet(str) {
    var out = {};
    String(str || '').split('|').forEach(function (t) { t = t.trim(); if (t) out[t] = 1; });
    return out;
  }

  class SimilarProducts extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      var self = this;
      var go = function () { self.load(); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); go(); }
        }, { rootMargin: '300px' });
        io.observe(this);
      } else {
        go();
      }
    }

    load() {
      var self = this;
      this.pick().then(function (handles) {
        if (handles.length >= 2) return self.renderCards(handles);
        return self.fallback();
      }).catch(function () { return self.fallback(); });
    }

    pick() {
      var d = this.dataset;
      var type = (d.type || '').replace(/"/g, '');
      var vendor = (d.vendor || '').replace(/"/g, '');
      var price = parseFloat(d.price) || 0;
      var limit = parseInt(d.limit, 10) || 4;
      var me = d.handle;
      var myTags = tagSet(d.tags);
      var meDead = /^dead\b/i.test(d.title || '');
      if (!type && !vendor) return Promise.resolve([]);

      var queries = [];
      if (type && vendor) queries.push('product_type:"' + type + '" AND vendor:"' + vendor + '"');
      queries.push(type ? 'product_type:"' + type + '"' : 'vendor:"' + vendor + '"');

      return Promise.all(queries.map(candidates)).then(function (lists) {
        var seen = {};
        var pool = [];
        lists.forEach(function (list) {
          list.forEach(function (c) {
            if (!c.h || c.h === me || seen[c.h]) return;
            seen[c.h] = 1;
            pool.push(c);
          });
        });

        pool.forEach(function (c) {
          var s = 0;
          if (price > 0 && c.p > 0) {
            var diff = Math.abs(c.p - price) / price;
            s += Math.max(0, 1 - diff) * 45;            // price closeness (0..45)
            if (c.p > price * 2.5 || c.p < price * 0.35) s -= 25;
          }
          if (vendor && c.v === d.vendor) s += 25;       // same brand
          var ct = tagSet(c.g), cond = 0, spec = 0;
          Object.keys(ct).forEach(function (t) {
            if (!myTags[t]) return;
            if (CONDITION.indexOf(t) !== -1) cond = 10;  // same condition
            else if (/^\d+(gb|tb)$/.test(t)) spec += 4;   // same storage / RAM
          });
          s += cond + Math.min(spec, 12);
          if (!meDead && /^dead\b/i.test(c.t || '')) s -= 60;   // never suggest non-working units
          c.s = s;
        });

        pool.sort(function (a, b) { return b.s - a.s; });
        return pool.filter(function (c) { return c.s > 0; }).slice(0, limit).map(function (c) { return c.h; });
      });
    }

    renderCards(handles) {
      var self = this;
      var q = handles.map(function (h) { return 'handle:' + h; }).join(' OR ');
      return fetchSection(q).then(function (doc) {
        var map = {};
        doc.querySelectorAll('li[data-handle]').forEach(function (li) { map[li.getAttribute('data-handle')] = li; });
        var items = handles.filter(function (h) { return map[h]; }).map(function (h) { return map[h]; });
        if (items.length < 2) return self.fallback();
        var d = self.dataset;
        var ul = '<ul class="grid product-grid grid--' + esc(d.colsDesktop || 4) + '-col-desktop grid--' + esc(d.colsMobile || 2) + '-col-tablet-down" role="list">' +
          items.map(function (li) { return '<li class="grid__item">' + li.innerHTML + '</li>'; }).join('') + '</ul>';
        self.innerHTML = '<h2 class="' + esc(d.headingClass || 'related-products__heading inline-richtext h2') + '">' + esc(d.heading || 'You may also like') + '</h2>' + ul;
      });
    }

    fallback() {
      var self = this;
      var url = this.dataset.nativeUrl;
      if (!url) return Promise.resolve();
      return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('similar-products');
        if (el && el.innerHTML.trim().length) self.innerHTML = el.innerHTML;
      }).catch(function () {});
    }
  }

  customElements.define('similar-products', SimilarProducts);
})();
